// ======================== card product selected variant id pass ====================== //

// function selectVariant(selectEl) {
//   const selectedVariantId = selectEl.value;

//   const cardContent = selectEl.closest('.card__content');

//   if (cardContent) {
//     const hiddenInput = cardContent.querySelector('.product-variant-id');
//     if (hiddenInput) {
//       hiddenInput.value = selectedVariantId;
//     }
//   }

//   if (cardContent) {
//     const addToCartBtn = cardContent.querySelector('.megamenu-add-to-cart');
//     if (addToCartBtn) {
//       addToCartBtn.disabled = false;
//     } else {
//       addToCartBtn.disabled = true;
//     }
//   }
// }

// document.querySelectorAll('product-form form').forEach((form) => {
//   form.addEventListener('submit', function (e) {
//     const hiddenInput = form.querySelector('.product-variant-id');
//     if (!hiddenInput.value) {
//       e.preventDefault();
//       alert("Please select a size before adding to cart.");
//     }
//   });
// });

function selectCardOption(selectEl, productId) {
  const card = selectEl.closest('.card__content');
  const variants = JSON.parse(card.getAttribute('data-variants'));
  const optionSelectors = card.querySelectorAll('[data-option-position]');

  const selectedOptions = Array.from(optionSelectors).map(el => ({
    position: el.dataset.optionPosition,
    value: el.value
  }));

  const matchedVariant = variants.find(v =>
    selectedOptions.every(opt => v.options[opt.position - 1] === opt.value)
  );

  const variantInput = card.querySelector('.product-variant-id');
  const addBtn = card.querySelector('.quick-add__submit');

  // --- Price update elements ---
  const regularPriceEl = card.querySelector('.price__regular .price-item--regular');
  const salePriceEl = card.querySelector('.price__sale .price-item--sale');
  const comparePriceEl = card.querySelector('.price__sale s.price-item--regular');

  // --- Fallback money formatter ---
  const formatMoney = (amount) => {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(amount, Shopify.money_format);
  }
  // Fallback: format with commas and 2 decimals
  const number = (amount / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return `$${number}`;
};

  if (matchedVariant) {
    // Update price display
    if (matchedVariant.compare_at_price > matchedVariant.price) {
      // Show sale pricing
      if (salePriceEl) salePriceEl.textContent = formatMoney(matchedVariant.price);
      if (comparePriceEl) comparePriceEl.textContent = formatMoney(matchedVariant.compare_at_price);
    } else {
      // Regular price only
      if (regularPriceEl) regularPriceEl.textContent = formatMoney(matchedVariant.price);
    }

    // Enable Add to Cart if available
    if (matchedVariant.available) {
      variantInput.value = matchedVariant.id;
      variantInput.disabled = false;
      addBtn.disabled = false;
    } else {
      variantInput.value = '';
      variantInput.disabled = true;
      addBtn.disabled = true;
    }
  } else {
    // Reset state if invalid selection
    variantInput.value = '';
    variantInput.disabled = true;
    addBtn.disabled = true;
  }
}

// --- Validate form on submit ---
document.querySelectorAll('product-form form').forEach((form) => {
  form.addEventListener('submit', function (e) {
    const hiddenInput = form.querySelector('.product-variant-id');
    if (!hiddenInput || !hiddenInput.value) {
      e.preventDefault();
      alert("Please select a size before adding to cart.");
    }
  });
});

// ==================== Megamenu hover open js =================== //

document.querySelectorAll('[id^="Details-"].mega-menu').forEach(menu => {
  const summary = menu.querySelector('summary');

  menu.addEventListener('mouseenter', () => {
    summary.setAttribute('aria-expanded', 'true');
    menu.setAttribute('open', 'open');
    document.body.classList.add('megamenu__overflow-hidden');
  });

  menu.addEventListener('mouseleave', () => {
    summary.setAttribute('aria-expanded', 'false');
    menu.removeAttribute('open');
    document.body.classList.remove('megamenu__overflow-hidden');
  });

  const overlay = menu.querySelector('.block__menu-overlay');
  if (overlay) {
    overlay.addEventListener('mouseenter', () => {
      summary.setAttribute('aria-expanded', 'false');
      menu.removeAttribute('open');
      document.body.classList.remove('megamenu__overflow-hidden');
    });
  }
});

// ========================= Swiper Slider js ===================== // 

document.addEventListener('DOMContentLoaded', function () {
  const BenefitsBarCarousel = document.querySelector('.block__benefits-bar-slider-inner');
  if (BenefitsBarCarousel)
    var swiper = new Swiper(BenefitsBarCarousel, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      loop: true,
      speed: 3000,
      autoplay: {
        delay: 0,
      },
    });

  const ProductSlider = document.querySelectorAll('.block__megamenu-product-slider');
  if (ProductSlider)
    ProductSlider.forEach(slider => {
      var swiper = new Swiper(slider, {
        slidesPerView: 2,
        spaceBetween: 16,
        loop: true,
        breakpoints: {
          200: { slidesPerView: 'auto', spaceBetween: 8 },
          990: { slidesPerView: 2, spaceBetween: 16 }
        },
      });
    });
});


// ========================= End Swiper Slider js ===================== // 

document.addEventListener("change", function (event) {
  if (event.target.matches(".block_subscription-options input[type=radio]")) {
    const radio = event.target;
    const wrapper = radio.closest(".product__info-wrapper");
    const drawer = wrapper.querySelector(".block_product-subscribe_drawer");
    if (radio.checked && radio.value === "subscribe") {
      drawer && drawer.classList.add("show-subscription");
      let handleSelectChange = function () {
        const selectedValue = select.value;
        subscriptionVal && (subscriptionVal.value = selectedValue);
        // if (selectedValue != '') {
        //   select.closest('.block_product-subscribe_multiple').classList.remove('show-subscription');
        //   drawer && drawer.classList.remove('show-subscription');
        // }
      };
      const select = radio.closest(".product__info-wrapper").querySelector(".block_product-subscribe_drawer select"),
        getInputVal = select ? select.value : null,
        subscriptionVal = radio.closest(".product__info-wrapper").querySelector(".block__product-form-input-selling-plan");
      subscriptionVal && (subscriptionVal.value = getInputVal), select.removeEventListener("change", handleSelectChange), select.addEventListener("change", handleSelectChange)
    } else {
      drawer && drawer.classList.remove("show-subscription");
      const getInputVal = radio.value,
        subscriptionVal = radio.closest(".product__info-wrapper").querySelector(".block__product-form-input-selling-plan");
      subscriptionVal && (subscriptionVal.value = getInputVal)
    }
  }
});

function getSelectedPriceAndQuantity(container) {
  const quantityInput = container.querySelector('.quantity__input');
  if (!quantityInput) return null;

  let unitPrice = 0;

  // Check for subscription price
  const checkedRadio = container.querySelector('.shopify_subscriptions_app_block_label input[type=radio]:checked');
  if (checkedRadio) {
    const priceElement = checkedRadio.closest('.shopify_subscriptions_app_block_label')?.querySelector('.block_product-grid_subscribe-price');
    if (priceElement) {
      const rawPrice = priceElement.getAttribute('data-price') || '0';
      unitPrice = parseFloat(rawPrice.replace(/[^0-9.]/g, '')) || 0;
    }
  }

  // Fallback: Use regular product price
  if (!unitPrice) {
    const priceElement = container.querySelector('.price__regular .price-item--regular');
    if (!priceElement) return null;
    const rawPrice = priceElement.textContent || '0';
    unitPrice = parseFloat(rawPrice.replace(/[^0-9.]/g, '')) || 0;
  }

  const quantity = parseInt(quantityInput.value, 10);
  if (isNaN(unitPrice) || isNaN(quantity)) return null;

  const total = unitPrice * quantity;
  const formattedPrice = window?.Shopify?.formatMoney
    ? Shopify.formatMoney(total * 100, window.Shopify.currency.active_format || window.Shopify.money_format)
    : `$${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  return {
    formattedPrice,
    unitPrice,
    quantity
  };
}

function updateDisplayPrices(container) {
  const result = getSelectedPriceAndQuantity(container);
  if (!result) return;

  const { formattedPrice } = result;

  // Update Add to Cart button price
  const addToCartSpan = container.querySelector('.product-form__submit .add-to-cart-price');
  if (addToCartSpan) {
    addToCartSpan.textContent = `Add to Cart - ${formattedPrice}`;
  }
  // const addToCartButton = container.querySelector('.quick-add__submit.button');
  // if (addToCartButton) {
  //   addToCartButton.textContent = `${formattedPrice}`;
  // }
}

document.querySelectorAll('.shopify_subscriptions_app_block_label input[type=radio]').forEach(radio => {
  radio.addEventListener('change', function () {
    const container = radio.closest('.product');
    if (!container) return;
    updateDisplayPrices(container);
  });
});

// Add to cart button price update on quantity change
function initQuantityListener() {
  document.querySelectorAll('.quantity__input').forEach(input => {
    input.addEventListener('change', () => {
      const container = input.closest('.product');
      if (!container) return;
      updateDisplayPrices(container);
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initQuantityListener();
});

// ========================== rebuy add to cart Click start   ============================= //

const observer = new MutationObserver(() => {
  const rebuyButtons = document.querySelectorAll('.rebuy-button');
  rebuyButtons.forEach(button => {
    if (!button.dataset.listenerAdded) {
      button.addEventListener('click', function () {
        const span = button.querySelector('span');
        const text = span?.textContent?.trim();

        if (text && (
          text.includes('Adding') ||
          text.includes('Added')
        )) {
          setTimeout(function () {
            updateCart();
            let cartDrawer = document.querySelector('body.product cart-drawer');
            if (cartDrawer) {
              cartDrawer.classList.add('active');
            }
          }, 1000);
        }
      });
      button.dataset.listenerAdded = 'true';
    }
  });
});
observer.observe(document.body, { childList: true, subtree: true });


function openCart(event) {
  console.log(event)
  let cartDrawer = document.querySelector('body.product cart-drawer');
  if (cartDrawer) {
    event.preventDefault();
    cartDrawer.classList.add('active');
  }
}

// ========================== rebuy add to cart Click End   ============================= //

// ============================= Video Play Js ======================= //

document.addEventListener('DOMContentLoaded', function () {
  const video_1 = document.getElementById('video_1');
  const circlePlayButton_1 = document.getElementById('circle-play-a');
  const videoImage_1 = document.querySelector('.video_thumbnail_image');

  if (video_1 && circlePlayButton_1 && videoImage_1) {
    circlePlayButton_1.addEventListener('click', function (event) {
      event.target.closest('.featured-collection-video-wrapper').querySelector('.video_thumbnail_image').style.display =
        'none';
      event.target.closest('.featured-collection-video-wrapper').querySelector('#video_1').style.display = 'block';

      if (video_1.paused || video_1.ended) {
        video_1.play();
      } else {
        video_1.pause();
      }
    });

    video_1.addEventListener('playing', function () {
      circlePlayButton_1.style.opacity = 0;
    });

    video_1.addEventListener('pause', function () {
      circlePlayButton_1.style.opacity = 1;
    });
  }
});

/* =================== Open address form popup js =================== */

function openForm(button) {
  const addressForm = button.closest('.address-form');
  const formWrapper = addressForm.querySelector('.form-wrapper');
  if (formWrapper) {
    formWrapper.classList.add('active');
    document.querySelector('body').classList.add('overflow-hidden');
  }
}

/* =================== Cancel address form popup js =================== */

function cancelForm(button) {
  const formWrapper = button.closest('.form-wrapper');
  if (formWrapper) {
    formWrapper.classList.remove('active');
    document.querySelector('body').classList.remove('overflow-hidden');
  }
}

/* Start blog tag menu redirect and pagination js */

function blogFind(datHref) {
  fetch(datHref)
    .then((response) => response.text())
    .then((responseText) => {
      let html = new DOMParser().parseFromString(responseText, "text/html");
      let targetElement = document.querySelector(".main-blog");
      let sourceElement = html.querySelector(".main-blog");
      if (targetElement && sourceElement) {
        targetElement.replaceWith(sourceElement);
      }
    });
}
function blogpagination(event, datHref) {
  let nextPage = event.target.getAttribute("data-currentpage");
  let maxPage = event.target.getAttribute("data-totalpage");
  let dataurl = `${datHref}?page=${nextPage}`;

  fetch(dataurl)
    .then((response) => response.text())
    .then((responseText) => {
      let html = new DOMParser().parseFromString(responseText, "text/html");
      let targetElement = document.querySelector(".blog-articles");
      let sourceElement = html.querySelectorAll(".blog-articles__article");
      for (html of sourceElement) {
        if (targetElement && sourceElement) {
          targetElement.appendChild(html);
        }
      }
      event.target.setAttribute("data-currentpage", Number(nextPage) + 1);
    })
    .finally(() => {
      if (nextPage == maxPage) {
        event.target.remove();
      }
    });
}

/* End blog tag menu redirect and pagination js */

/* Subscription Add to Cart Value Set Start */

document.addEventListener('change', function (event) {
  if (event.target.matches('.block_subscription-options input[type=radio]')) {
    const radio = event.target;

    if (radio.checked && radio.value === "subscribe") {
      const subscribeOpt = radio.closest(".block__product-info-inner");
      const select = subscribeOpt.querySelector(".block_product-subscribe_drawer select");
      const getInputVal = select ? select.value : null;

      const infoCard = radio.closest(".block__product-info-inner");
      const subscriptionVal = infoCard.querySelector(".block__product-card-subscription-val");
      if (subscriptionVal) {
        subscriptionVal.value = getInputVal;
      }

      select.removeEventListener('change', handleSelectChange);
      select.addEventListener('change', handleSelectChange);

      function handleSelectChange() {
        const selectedValue = select.value;
        if (subscriptionVal) {
          subscriptionVal.value = selectedValue;
        }
      }
    } else {
      const getInputVal = radio.value;
      const infoCard = radio.closest(".block__product-info-inner");
      const subscriptionVal = infoCard.querySelector(".block__product-card-subscription-val");
      if (subscriptionVal) {
        subscriptionVal.value = getInputVal;
      }
    }
  }
});
